import React, { Component } from 'react'
import FlatButton from 'material-ui/FlatButton'
import Checkbox from 'material-ui/Checkbox'
import UncheckedIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank'
import { FormattedMessage } from 'react-intl'
import images from '../../../config/images'

export default function changeList (ListItem) {
  class List extends Component {
    state = {
      changeColumn: false,
      selected: false
    }

    componentWillReceiveProps (nextProps) {
      if (nextProps.initiallyOpen !== this.props.initiallyOpen) {
        this.setState({selected: nextProps.initiallyOpen})
      }
    }

    handleMouseEnter = (e) => {
      this.setState({changeColumn: true})
    }

    handleMouseOut = (e) => {
      this.setState({changeColumn: false})
    }

    handleSelection = (e, isInputChecked, members, id) => {
      this.setState({selected: isInputChecked})
      this.props.onNestedListToggle(isInputChecked, members, id)
    }

    render () {
      if (this.state.selected) {
        return (
          <ListItem
            {...this.props}
            onMouseOut={this.handleMouseOut}
            style={{background: 'rgba(41, 184, 122, 0.15)'}}
            leftCheckbox={
              <Checkbox
                defaultChecked={this.state.selected}
                onCheck={(e, isInputChecked) => this.handleSelection(e, isInputChecked, this.props.data.total, this.props.data.id)}
                iconStyle={{fill: '#29B87A', marginTop: 5}}
                uncheckedIcon={<UncheckedIcon style={{fill: '#6B7C93'}}/>}
              />
            }
            primaryText={
              <div className='flex justify-between'>
                <div>
                  <div className='pb1'>{this.props.data.name}</div>
                  <div style={{fontSize: 12, color: '#6B7C93'}}>{this.props.data.total} <FormattedMessage
                    id='seminarActions.members'/></div>
                </div>
                <div>
                  <FlatButton
                    onTouchTap={(e) => this.handleSelection(e, !this.state.selected, this.props.data.total, this.props.data.id)}
                    label={<FormattedMessage id='seminarActions.select'/>}
                    backgroundColor='#45CE90'
                    labelStyle={{color: '#FFFFFF'}}/>
                </div>
              </div>
            }
          />
        )
      }
      return (this.state.changeColumn) ? (
        <ListItem
          {...this.props}
          defaultChecked={this.state.selected}
          onMouseOut={this.handleMouseOut}
          style={{background: 'rgba(45, 146, 238, 0.05)'}}
          leftCheckbox={
            <Checkbox
              onCheck={(e, isInputChecked) => this.handleSelection(e, isInputChecked, this.props.data.total, this.props.data.id)}
              iconStyle={{fill: '#29B87A', marginTop: 5}}
              uncheckedIcon={<UncheckedIcon style={{fill: '#6B7C93'}}/>}
            />
          }
          primaryText={
            <div className='flex justify-between'>
              <div>
                <div className='pb1'>{this.props.data.name}</div>
                <div style={{fontSize: 12, color: '#6B7C93'}}>{this.props.data.total} <FormattedMessage
                  id='seminarActions.members'/></div>
              </div>
              <div>
                <FlatButton
                  onTouchTap={(e) => this.handleSelection(e, !this.state.selected, this.props.data.total, this.props.data.id)}
                  label={<FormattedMessage id='seminarActions.selectList'/>} labelStyle={{color: '#2D92EE'}}/>
              </div>
            </div>
          }
        />
      ) : (
        <ListItem
          {...this.props}
          onMouseOver={this.handleMouseEnter}
          leftCheckbox={
            <div className='h-100 flex items-center' style={{height: 40, width: 40}}>
              <img src={images.inviteUserIcon} alt='user'/>
            </div>
          }
          primaryText={
            <div className='flex justify-between'>
              <div>
                <div className='pb1'>{this.props.data.name}</div>
                <div style={{fontSize: 12, color: '#6B7C93'}}>{this.props.data.total} <FormattedMessage
                  id='seminarActions.members'/></div>
              </div>
              <div>
                <FlatButton
                  label={<FormattedMessage id='seminarActions.selectList'/>}
                  labelStyle={{color: '#2D92EE'}}/>
              </div>
            </div>
          }
        />
      )
    }
  }

  return List
}



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/InviteListHOC.js